module.exports = [
    { value: 'draft',   label: 'Entwurf' },
    { value: 'online',    label: 'Online' },
    { value: 'inactive',    label: 'Inaktiv' },
    { value: 'offline',   label: 'Offline' },
];
